export default "__VITE_ASSET__APlejQwd__"